module.exports = __webpack_public_path__ + "static/media/06.f60bb68d.gif";